import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { StaticQuery } from 'gatsby';
import ListGroup from '../components/ListGroup';
var ExampleNavigation = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ExampleNavigation, _React$Component);
  function ExampleNavigation() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = ExampleNavigation.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      selectedId = _this$props.selectedId,
      items = _this$props.items;
    return /*#__PURE__*/React.createElement("div", {
      className: "nav nav-example"
    }, /*#__PURE__*/React.createElement(ListGroup, {
      selectedId: selectedId,
      items: items
    }));
  };
  return ExampleNavigation;
}(React.Component);
var NavigationWrapper = function NavigationWrapper(props) {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "1348573739",
    render: function render(data) {
      return /*#__PURE__*/React.createElement(ExampleNavigation, Object.assign({
        items: data.allNavigationJson.edges
      }, props));
    }
  });
};
export default NavigationWrapper;